<template>
    <div class="panel panel-default" data-testid="order-detail-saga-hops">
        <div class="panel-heading">
            <h4>{{ order.ui.labels.sagaHops }}</h4>
        </div>
        <div class="panel-body no-padding">
            <p v-if="!hops.length" class="text-muted od-empty" data-testid="order-detail-saga-hops-empty">
                {{ emptyLabel }}
            </p>
            <ul v-else class="od-hops" data-testid="order-detail-saga-hops-list">
                <li
                    v-for="hop in hops"
                    :key="hop.hop"
                    class="od-hops__item"
                    :data-testid="'order-detail-saga-hop-' + hop.hop"
                >
                    <span class="od-hops__num">{{ hop.hop }}</span>
                    <div class="od-hops__body">
                        <div class="od-hops__title-row">
                            <p class="od-hops__title" :title="hop.label">{{ hopTitle(hop) }}</p>
                            <span class="od-hops__badges">
                                <span v-if="hop.downstreamFailure" class="od-badge od-badge--waiting">Downstream</span>
                                <od-status-badge :status="hop.status" />
                            </span>
                        </div>
                        <p class="od-hops__date">{{ formatDate(hop.occurredAt) }}</p>
                        <p v-if="hop.error" class="od-hops__error">{{ hop.error }}</p>
                        <od-collapsible-details :pairs="hopPairs(hop)" />
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import OdCollapsibleDetails from './OdCollapsibleDetails.vue';
import OdStatusBadge from './OdStatusBadge.vue';
import { eventLabel, formatDate, parseTechPairs } from './orderDetailHelpers';

export default {
    name: 'OrderSagaHops',
    components: { OdCollapsibleDetails, OdStatusBadge },
    props: {
        order: {
            type: Object,
            required: true,
        },
    },
    computed: {
        hops() {
            const rows = this.order.sagaHops;
            if (!Array.isArray(rows)) {
                return [];
            }

            return rows.filter((hop) => hop && hop.status !== 'not_persisted' && hop.status !== 'not_reached');
        },
        emptyLabel() {
            return this.order.ui?.labels?.hopsEmpty || 'Nessun dato persistito';
        },
    },
    methods: {
        formatDate,
        hopTitle(hop) {
            return eventLabel(hop.label || `Hop ${hop.hop}`);
        },
        hopPairs(hop) {
            const pairs = parseTechPairs(hop.detail);
            if (pairs.length) {
                return pairs;
            }
            if (hop.links && typeof hop.links === 'object') {
                return Object.entries(hop.links)
                    .filter(([, value]) => value != null && value !== '')
                    .map(([key, value]) => [key, String(value)]);
            }

            return [];
        },
    },
};
</script>
